import { Route } from 'types/route.type';
import Overview from 'views/overview/overview';

// salmon
import { routes as bestmix } from '../feed-management/routes';
import { routes as fileSharing } from '../file-sharing/routes';
import { routes as fishCheck } from '../fish-check/routes';
import { routes as orders } from '../order-feed/routes';
import { routes as planningPrognosis } from '../planning-prognosis/routes';
import { routes as powerBIReports } from '../power-bi-reports/routes';
import { routes as profilesStrategies } from '../profiles-strategies/routes';
import { routes as bluViuNutrition } from '../bluviu-nutrition/routes';
import { routes as seaCloudFileUpload } from '../sea-cloud-file-upload/routes';
import { routes as settings } from '../settings/routes';
import { routes as siteSettings } from '../site-settings/routes';

import { routes as playground } from '../playground/routes';

// shrimp
import { routes as production } from '../production-systems/routes';
import { routes as selfService } from '../self-service/routes';
import { routes as shrimpdataupload } from '../shrimp-data-upload/routes';
import { routes as benchmarkAnalytics } from '../benchmark-analytics/routes';

const defaults: Route[] = [
  {
    path: '/overview',
    component: Overview,
    id: 'features.overview',
  },
  {
    path: '/delivery-board',
    component: Overview,
    id: 'features.deliveryBoard',
  },
];


export const routes: Route[] = [
  ...defaults,
  ...siteSettings,
  ...orders,
  ...profilesStrategies,
  ...planningPrognosis,
  ...bluViuNutrition,
  ...bestmix,
  ...fishCheck,
  ...powerBIReports,
  ...seaCloudFileUpload,
  ...fileSharing,
  ...shrimpdataupload,
  ...benchmarkAnalytics,
  ...settings,

  ...production,
  ...selfService,

  ...playground,
];
